import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import API_URL from '../config';
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);

const getDefaultState = () => {
    return {
        vuex: (localStorage.getItem('vuex')) ? JSON.parse(localStorage.getItem('vuex')) : {user: null, token: null},
        token: localStorage.getItem('accessToken'),
        user: {},
        ellipses_array: null,
        gsv_ellipses_array: null,
        userId: null,
        statistics: null,
        loading: false,
        refreshToken: (localStorage.getItem('refreshToken')) ? localStorage.getItem('refreshToken') : null,
        new_colors: {
            color_gsv_1: '#8ec4dd', color_gsv_22: '#78a7bc', color_gsv_38: '#0085b7', color_gsv_2: '#8ec4dd', color_gsv_39: '#74a1b6', color_gsv_23: '#78a7bc',
            color_gsv_40: '#74a1b6', color_gsv_24: '#0085b7',color_gsv_25: '#0085b7',color_gsv_26: '#0085b7',color_gsv_27: '#0085b7',color_gsv_28: '#0085b7',
            color_gsv_29: '#0085b7',color_gsv_30: '#0085b7', color_gsv_41: '#74a1b6', color_gsv_3: '#8ec4dd', color_gsv_4: '#8ec4dd', color_gsv_5: '#8ec4dd',
            color_gsv_6: '#8ec4dd', color_gsv_7: '#8ec4dd', color_gsv_8: '#8ec4dd', color_gsv_57: '#00a1de', color_gsv_19: '#8ec4dd', color_gsv_9: '#8ec4dd',
            color_gsv_10: '#00a1de', color_gsv_58: '#78a7bc', color_gsv_20:'#78a7bc',  color_gsv_21:'#74a1b6', color_gsv_42: '#0085b7', color_gsv_31: '#0085b7',
            color_gsv_32: '#0085b7',color_gsv_33: '#0085b7',color_gsv_34: '#0085b7',color_gsv_35: '#0085b7', color_gsv_36: '#0085b7',color_gsv_37: '#8ec4dd',
            color_gsv_11: '#74a1b6', color_gsv_43:'#74a1b6',  color_gsv_44: '#8ec4dd', color_gsv_12: '#8ec4dd', color_gsv_13: '#8ec4dd', color_gsv_14: '#8ec4dd', color_gsv_15: '#8ec4dd',
            color_gsv_45: '#00a1de', color_gsv_46: '#00a1de', color_gsv_47:'#00a1de', color_gsv_48: '#00a1de', color_gsv_49: '#00a1de', color_gsv_50: '#00a1de',
            color_gsv_51: '#00a1de', color_gsv_52: '#00a1de',color_gsv_53: '#00a1de', color_gsv_54: '#00a1de',color_gsv_55: '#00a1de',color_gsv_56: '#00a1de',
            color_gsv_16: '#8ec4dd',   color_gsv_17: '#8ec4dd',color_gsv_59: '#8ec4dd', color_gsv_18: '#8ec4dd', color_gsv_60: '#8ec4dd', color_gsv_61: '#78a7bc',
            color_gsv_62: '#78a7bc', color_gsv_63: '#78a7bc',color_gsv_64: '#8ec4dd', color_gsv_65: '#00A0DD',color_gsv_66: '#00A0DD',color_gsv_67: '#00A0DD',
            color_gsv_68: '#00A0DD',color_gsv_69: '#00A0DD',color_gsv_70: '#00A0DD',color_gsv_71: '#00A0DD',color_gsv_72: '#00A0DD',color_gsv_73: '#00A0DD',
            color_gsv_74: '#00A0DD',color_gsv_75: '#00A0DD',color_gsv_76: '#00A0DD',color_gsv_77: '#00A0DD',color_gsv_78: '#00A0DD',color_gsv_79: '#00A0DD',color_gsv_80: '#00A0DD',

        },
        gsv_dots: {dot_1:'transparent', dot_2:'transparent', dot_3:'transparent', dot_4:'transparent', dot_5:'transparent', dot_6:'transparent', dot_7:'transparent', dot_8:'transparent', dot_9:'transparent', dot_10:'transparent',
            dot_11:'transparent', dot_12:'transparent', dot_13:'transparent', dot_14:'transparent', dot_15:'transparent', dot_16:'transparent', dot_17:'transparent', dot_18:'transparent', dot_19:'transparent', dot_20:'transparent',
            dot_21:'transparent',dot_22:'transparent',dot_23:'transparent',dot_24:'transparent',dot_25:'transparent',dot_26:'transparent',dot_27:'transparent',dot_28:'transparent',dot_29:'transparent',dot_30:'transparent',
            dot_31:'transparent',dot_32:'transparent',dot_33:'transparent',dot_34:'transparent',dot_35:'transparent',dot_36:'transparent',dot_37:'transparent',dot_38:'transparent',dot_39:'transparent',dot_40:'transparent',dot_41:'transparent',dot_42:'transparent',dot_43:'transparent',
            dot_44:'transparent',dot_45:'transparent',dot_46:'transparent',dot_47:'transparent',dot_48:'transparent',dot_49:'transparent',dot_50:'transparent',dot_51:'transparent',
            dot_52:'transparent',dot_53:'transparent',dot_54:'transparent',dot_55:'transparent', dot_56:'transparent', dot_57:'transparent'
        },

        gsv_partial: {
            partial_1:'transparent',partial_2:'transparent',partial_3:'transparent',partial_4:'transparent',partial_5:'transparent',partial_6:'transparent',partial_7:'transparent',partial_8:'transparent',
            partial_9:'transparent',partial_10:'transparent',partial_11:'transparent',partial_12:'transparent',partial_13:'transparent',
            partial_14:'transparent',partial_15:'transparent', partial_16:'transparent',partial_17:'transparent',partial_18:'transparent',partial_19:'transparent',partial_20:'transparent', partial_21:'transparent', partial_22:'transparent', partial_23:'transparent',
            partial_24:'transparent', partial_25:'transparent', partial_26:'transparent', partial_27:'transparent', partial_28:'transparent', partial_29:'transparent',
            partial_30:'transparent', partial_31:'transparent', partial_32:'transparent', partial_33:'transparent', partial_34:'transparent', partial_35:'transparent', partial_36:'transparent'
        },

        ssv_colors: {
            color_ssv_1: '#8ec4dd', color_ssv_2: '#8ec4dd', color_ssv_3: '#8ec4dd', color_ssv_4: '#8ec4dd', color_ssv_5: '#8ec4dd', color_ssv_6: '#8ec4dd',color_ssv_7: '#8ec4dd', color_ssv_8: '#8ec4dd'
        },

        ssv_dots: {
            dot_1:'transparent', dot_2:'transparent', dot_3:'transparent', dot_4:'transparent', dot_5:'transparent', dot_6:'transparent', dot_7:'transparent', dot_8:'transparent', dot_9:'transparent', dot_10:'transparent',
            dot_11:'transparent', dot_12:'transparent', dot_13:'transparent', dot_14:'transparent'
        },

        ssv_partial: {partial_1:'transparent',partial_2:'transparent',partial_3:'transparent',partial_4:'transparent',partial_5:'transparent',partial_6:'transparent',}
    };
};
export default new Vuex.Store({
    strict: true,
    //plugins: [createPersistedState()],
    state: getDefaultState(),
    getters: {
        isLoggedIn: state => {
            return state.token;
        },
        getUser: state => {
            return state.user;
        }
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
            state.vuex.token = token
            localStorage.setItem('accessToken', token)
            localStorage.setItem('vuex', JSON.stringify(state.vuex))
        },
        SET_REFRESH_TOKEN: (state, token) => {
            state.refreshToken = token;
            localStorage.setItem('refreshToken', token)
        },
        SET_USER: (state, user) => {
            state.user = user;
            state.vuex.user = user
            localStorage.setItem('vuex', JSON.stringify(state.vuex))
        },
        RESET: state => {
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('accessToken')
            Object.assign(state, getDefaultState());
            localStorage.setItem('vuex', JSON.stringify({user: null, token: null}))
        },
        SET_STATISTICS: (state, data) => {
            state.statistics = data
        },

        setLoading: (state, value) => {
            state.loading = value
        },
        UPDATE_COLORS(state, data) {
            state.new_colors[data.index] = data.color
        },

        UPDATE_DOT_COLORS(state, data) {
            state.gsv_dots[data.index] = data.color
            state.gsv_partial[data.partial_index] = data.partial
        },

        SET_DEFAULT_COLORS(state) {
            state.ssv_colors = {
                color_ssv_1: '#8ec4dd', color_ssv_2: '#8ec4dd', color_ssv_3: '#8ec4dd', color_ssv_4: '#8ec4dd', color_ssv_5: '#8ec4dd', color_ssv_6: '#8ec4dd', color_ssv_7: '#8ec4dd', color_ssv_8: '#8ec4dd'
            }
            state.ssv_dots = {
                dot_1:'transparent', dot_2:'transparent', dot_3:'transparent', dot_4:'transparent', dot_5:'transparent', dot_6:'transparent', dot_7:'transparent', dot_8:'transparent', dot_9:'transparent', dot_10:'transparent',
                    dot_11:'transparent', dot_12:'transparent', dot_13:'transparent', dot_14:'transparent'
            }

            state.ssv_partial = {partial_1:'transparent',partial_2:'transparent',partial_3:'transparent',partial_4:'transparent',partial_5:'transparent',partial_6:'transparent',}

            state.new_colors = {
                color_gsv_1: '#8ec4dd', color_gsv_22: '#78a7bc', color_gsv_38: '#0085b7', color_gsv_2: '#8ec4dd', color_gsv_39: '#74a1b6', color_gsv_23: '#78a7bc',
                    color_gsv_40: '#74a1b6', color_gsv_24: '#0085b7',color_gsv_25: '#0085b7',color_gsv_26: '#0085b7',color_gsv_27: '#0085b7',color_gsv_28: '#0085b7',
                    color_gsv_29: '#0085b7',color_gsv_30: '#0085b7', color_gsv_41: '#74a1b6', color_gsv_3: '#8ec4dd', color_gsv_4: '#8ec4dd', color_gsv_5: '#8ec4dd',
                    color_gsv_6: '#8ec4dd', color_gsv_7: '#8ec4dd', color_gsv_8: '#8ec4dd', color_gsv_57: '#00a1de', color_gsv_19: '#8ec4dd', color_gsv_9: '#8ec4dd',
                    color_gsv_10: '#00a1de', color_gsv_58: '#78a7bc', color_gsv_20:'#78a7bc',  color_gsv_21:'#74a1b6', color_gsv_42: '#0085b7', color_gsv_31: '#0085b7',
                    color_gsv_32: '#0085b7',color_gsv_33: '#0085b7',color_gsv_34: '#0085b7',color_gsv_35: '#0085b7', color_gsv_36: '#0085b7',color_gsv_37: '#8ec4dd',
                    color_gsv_11: '#74a1b6', color_gsv_43:'#74a1b6',  color_gsv_44: '#8ec4dd', color_gsv_12: '#8ec4dd', color_gsv_13: '#8ec4dd', color_gsv_14: '#8ec4dd', color_gsv_15: '#8ec4dd',
                    color_gsv_45: '#00a1de', color_gsv_46: '#00a1de', color_gsv_47:'#00a1de', color_gsv_48: '#00a1de', color_gsv_49: '#00a1de', color_gsv_50: '#00a1de',
                    color_gsv_51: '#00a1de', color_gsv_52: '#00a1de',color_gsv_53: '#00a1de', color_gsv_54: '#00a1de',color_gsv_55: '#00a1de',color_gsv_56: '#00a1de',
                    color_gsv_16: '#8ec4dd',   color_gsv_17: '#8ec4dd',color_gsv_59: '#8ec4dd', color_gsv_18: '#8ec4dd', color_gsv_60: '#8ec4dd', color_gsv_61: '#78a7bc',
                    color_gsv_62: '#78a7bc', color_gsv_63: '#78a7bc',color_gsv_64: '#8ec4dd', color_gsv_65: '#00A0DD',color_gsv_66: '#00A0DD',color_gsv_67: '#00A0DD',
                    color_gsv_68: '#00A0DD',color_gsv_69: '#00A0DD',color_gsv_70: '#00A0DD',color_gsv_71: '#00A0DD',color_gsv_72: '#00A0DD',color_gsv_73: '#00A0DD',
                    color_gsv_74: '#00A0DD',color_gsv_75: '#00A0DD',color_gsv_76: '#00A0DD',color_gsv_77: '#00A0DD',color_gsv_78: '#00A0DD',color_gsv_79: '#00A0DD',color_gsv_80: '#00A0DD',

            }
            state.gsv_dots = {dot_1:'transparent', dot_2:'transparent', dot_3:'transparent', dot_4:'transparent', dot_5:'transparent', dot_6:'transparent', dot_7:'transparent', dot_8:'transparent', dot_9:'transparent', dot_10:'transparent',
                dot_11:'transparent', dot_12:'transparent', dot_13:'transparent', dot_14:'transparent', dot_15:'transparent', dot_16:'transparent', dot_17:'transparent', dot_18:'transparent', dot_19:'transparent', dot_20:'transparent',
                dot_21:'transparent',dot_22:'transparent',dot_23:'transparent',dot_24:'transparent',dot_25:'transparent',dot_26:'transparent',dot_27:'transparent',dot_28:'transparent',dot_29:'transparent',dot_30:'transparent',
                dot_31:'transparent',dot_32:'transparent',dot_33:'transparent',dot_34:'transparent',dot_35:'transparent',dot_36:'transparent',dot_37:'transparent',dot_38:'transparent',dot_39:'transparent',dot_40:'transparent',dot_41:'transparent',dot_42:'transparent',dot_43:'transparent',
                dot_44:'transparent',dot_45:'transparent',dot_46:'transparent',dot_47:'transparent',dot_48:'transparent',dot_49:'transparent',dot_50:'transparent',dot_51:'transparent',
                dot_52:'transparent',dot_53:'transparent',dot_54:'transparent',dot_55:'transparent', dot_56:'transparent', dot_57:'transparent',
            }

            state.gsv_partial = {
                partial_1:'transparent',partial_2:'transparent',partial_3:'transparent',partial_4:'transparent',partial_5:'transparent',partial_6:'transparent',partial_7:'transparent',partial_8:'transparent',
                    partial_9:'transparent',partial_10:'transparent',partial_11:'transparent',partial_12:'transparent',partial_13:'transparent',
                    partial_14:'transparent',partial_15:'transparent', partial_16:'transparent',partial_17:'transparent',partial_18:'transparent',partial_19:'transparent',partial_20:'transparent', partial_21:'transparent', partial_22:'transparent', partial_23:'transparent',
                 partial_24:'transparent', partial_25:'transparent', partial_26:'transparent', partial_27:'transparent', partial_28:'transparent', partial_29:'transparent',
                 partial_30:'transparent', partial_31:'transparent', partial_32:'transparent', partial_33:'transparent', partial_34:'transparent', partial_35:'transparent', partial_36:'transparent'
            }

        },

        UPDATE_SSV_COLORS(state, data) {
            state.ssv_colors[data.index] = data.color
        },

        UPDATE_SSV_DOT_COLORS(state, data) {
            state.ssv_dots[data.index] = data.color
            state.ssv_partial[data.partial_index] = data.partial
        },
    },
    actions: {
        login: ({ commit }, { token }) => {
            commit('SET_TOKEN', token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        },
        refreshToken: ({ commit },  token) => {
            commit('SET_REFRESH_TOKEN', token);
        },
        logout: ({ commit }) => {
            commit('RESET', '');
            localStorage.removeItem('accessToken');
        },
        getUserInfo: ({commit}) => {
            const url = API_URL + 'api/User/UserInfo';
            return new Promise((resolve, reject) => {
                axios.get(url)
                    .then((response) => {
                        commit('SET_USER', response.data);
                        resolve(response)
                    })
                    .catch((error) => {reject(error)})
            })
        },
        getDashboardStatistics({commit}) {
            return new Promise((resolve, reject) => {
                const url = 'https://sdy.spx.dotnet.vecto.it/api/Statistic';
                axios.get(url
                ).then((response) => {
                    commit('SET_STATISTICS', response.data);
                    resolve(response)
                })
                    .catch((error) => {
                       reject(error)
                    });
            })
        },

        updateAccessToken (ctx) {
            return new Promise((resolve, reject) => {
                const url = 'https://ms.spx.dotnet.vecto.it/api/Auth/RefreshToken'
                const payload = {
                    clientId: 'api_client',
                    clientSecret: 'api_secret',
                    refreshToken: ctx.state.refreshToken
                }
                axios.post(url, payload)
                    .then((response) => {
                        const token = response.data.accessToken;
                        const refreshToken = response.data.refreshToken;
                        ctx.dispatch('login', {token})
                        ctx.dispatch('refreshToken', refreshToken)
                        location.reload()
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
    }
});